import { render, staticRenderFns } from "./trawl-sub-menu.vue?vue&type=template&id=45cf7ae1&functional=true"
import script from "./trawl-sub-menu.vue?vue&type=script&lang=js"
export * from "./trawl-sub-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports